import { lazy } from "react";

const UpdateCompanyInfoPage = lazy(() => import("./update"));

export { UpdateCompanyInfoPage };
